package app.vercors.website.data

class Platform(val os: Os?, val arch: Arch)
